
import { Component, Mixins } from "vue-property-decorator";
import { IFontSizeAutoAdjustBehavior } from "../../../../../../documaker/domain/format/objects";
import { IFontSizeAutoAdjustBehaviorPropertyEditable, instanceOfIFontSizeAutoAdjustBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class FontSizeAutoAdjustBehaviorEditorPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IFontSizeAutoAdjustBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IFontSizeAutoAdjustBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isFontSizeAutoAdjustBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIFontSizeAutoAdjustBehaviorPropertyEditable(s) && s.fontSizeAutoAdjustBehavior().isEditable(), false);
  }

  get fontSizeAutoAdjustBehavior(): IFontSizeAutoAdjustBehavior {
    return this.readPropertyOrDefault(s => s.fontSizeAutoAdjustBehavior().getValue(), { isEnable: false });
  }

  set fontSizeAutoAdjustBehavior(value: IFontSizeAutoAdjustBehavior) {
    this.writePropertyWhenValid(s => s.fontSizeAutoAdjustBehavior().setValue(value));
  }
}
